import { envVars } from "@/plugins/env-vars";

const API_DOMAIN = envVars.getStr("VUE_APP_API_HOST");
const validateDomainPath = (val: string): string => {
  return val.replace(/\/$/, "");
};
export function goToWebinar(id: string, token: string) {
  let webinarRoute = document.createElement("a");
  webinarRoute.href = `${validateDomainPath(
    API_DOMAIN
  )}/webinar/${id}?jwt=${token}`;
  webinarRoute.target = "_blank";
  webinarRoute.click();
}
